import React, { useState, useEffect } from "react";
import { Button, Spinner } from "@material-tailwind/react";
import "./style.css";
import {
  db,
  ref,
  collection,
  serverTimestamp,
  onSnapshot,
  addDoc,
  uploadBytes,
  storage,
  getDownloadURL,
  setDoc,
  getDocs,
  where,
  query,
  doc,
} from "../../config/firebase";
import Swal from "sweetalert2";
import { PatternFormat } from "react-number-format";

export default function Payment() {
  const [rollNumber, setRollNumber] = useState("");
  const [selectMethod, setSelectMethod] = useState(""); // State to hold selected method
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [course, setCourse] = useState("");
  const [batch, setBatch] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (rollNumber && name && phone && selectedFile && selectMethod&&course&&batch) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [rollNumber, name, phone, selectedFile,selectMethod, course, batch]);

  // const handleFileInputChange = (event) => {
  //   const file = event.target.files[0];
  //   setSelectedFile(file);
  // };
  const handleMethodChange = (event) => {
    setSelectMethod(event.target.value); // Update selected method state
  };

  useEffect(() => {
    const que = collection(db, "Students");
    const unsubscribe = onSnapshot(
      que,
      async (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const roll2 = change.doc.data().rollNumber;
          if (roll2 == rollNumber) {
            const data = change.doc.data();
            console.log(data);
            setName(data.name);
            setPhone(data.phone);
            setCourse(data.course);
            setBatch(data.batch);
          }
        },
        [rollNumber]
        );

        return () => {
          unsubscribe();
        };
      },
      [rollNumber]
    );
  });

  function viewPic() {
    let img = document.getElementById("dropzone-file");
    document.getElementById("show").style.display = "flex";
    let prew = document.getElementById("img");
    const [file] = img?.files;

    setSelectedFile(file);
    if (file) {
      prew.src = URL.createObjectURL(file);
      document.getElementById("svg").style.display = "none";
      document.getElementById("svg2").style.display = "none";
    }
  }

  const Submit = () => {

    let method = document.getElementById("method");
    let id = document.getElementById("rolNum");
    let name = document.getElementById("name");
    let phone = document.getElementById("phone");
    let file = document.getElementById("dropzone-file");
    let course = document.getElementById("course");
    let batch = document.getElementById("batch");

    let errorMsg = "";
    if (!name.value || !id.value || !phone.value ||!course.value || !batch.value) {
      if (!name.value) errorMsg += "- Name\n";
      if (!phone.value) errorMsg += "- Phone number\n";
      if (!id.value) errorMsg += "- id\n";
      if (!selectMethod) errorMsg += "- Method\n";
      if (!course.value) errorMsg += "- Course\n";
      if (!batch.value) errorMsg += "- Batch\n";

      Swal.fire({
        icon: "error",
        title: "Following Fields are Required.",
        text: `${errorMsg}`,
      });
      return;
    }

    if (!file.files[0]) {
      Swal.fire({
        icon: "error",
        title: "Image Required.",
      });
      return;
    }

    const q = collection(db, "rollnumber");
    const unsubscribe = onSnapshot(q, async (snapshot) => {
      let idExists = false; // Flag to track if the ID exists in the collection

      snapshot.docChanges().forEach((change) => {
        const roll = change.doc.data().roll;
        if (roll == id.value) {
          idExists = true;
        }
      });

      document.getElementById("loader").style.display = "flex";

      if (idExists) {
        // Check if the user already exists in the "Payments" collection
        const paymentQuery = query(
          collection(db, "Payment"),
          where("rollnumber", "==", id.value)
        );

        const paymentQuerySnapshot = await getDocs(paymentQuery);

        if (!paymentQuerySnapshot.empty) {
          // User has already made a payment
          document.getElementById("loader").style.display = "none";
          Swal.fire({
            icon: "error",
            title: "Payment Already Made",
            text: "You have already made a payment.",
          });
        } else {
          try {
            // User does not exist in the "Payments" collection, proceed with payment
            const docRef = await addDoc(collection(db, "Payment"), {
              batch: batch.value,
              course: course.value,
              name: name.value,
              method: method.value,
              rollnumber: id.value,
              phone: phone.value,
              date: serverTimestamp(),
              id: "",
              status: "Unverified",
              pic: "",

            });

            const storageRef = ref(storage, `payment/${id.value}`);
            uploadBytes(storageRef, file.files[0])
              .then((snapshot) => {
                console.log("Uploaded a blob or file!");
              })
              .then(() => {
                getDownloadURL(ref(storage, `payment/${id.value}`))
                  .then(async (url) => {
                    await setDoc(doc(db, "Payment", docRef.id), {
                      batch: batch.value,
                      course: course.value,
                      name: name.value,
                      method: method.value,
                      rollnumber: id.value,
                      phone: phone.value,
                      date: serverTimestamp(),
                      id: docRef.id,
                      status: "Unverified",
                      pic: url,
                    });
                    Swal.fire({
                      icon: "success",
                      title: "Payment Verified  Successfully",
                      // footer:
                      //   '<a target="blank" href="https://chat.whatsapp.com/JoXXb703lNk3nWHnIlbjlF">Please Join WhatsApp Group : https://chat.whatsapp.com/JoXXb703lNk3nWHnIlbjlF</a>',
                    }).then(() => {
                      window.location.href = "/";
                    });
                    document.getElementById("loader").style.display = "none";
                    id.value = "";
                    name.value = "";
                    phone.value = "";
                    course.value = "";
                    batch.value = "";
                  })
                  .catch((error) => {
                    document.getElementById("loader").style.display = "none";
                    console.log(error);
                  });
              });
          } catch (e) {
            document.getElementById("loader").style.display = "none";
            console.error("Error adding document: ", e);
          }
        }
      } else {
        document.getElementById("loader").style.display = "none";
        alert("ID does not exist in the collection.");
      }
    });
  };

  return (
    <div className="flex justify-center  items-center ">
      <div
        id="loader"
        style={{ backgroundColor: "rgba(0,0,0,0.6)", top: "0" }}
        className="h-screen z-50 hidden fixed flex items-center w-full"
      >
        <div className="flex justify-center w-full  ">
          <Spinner
            className="h-32 w-32 sm:h-48 sm:w-48 md:h-64 md:w-64 lg:h-80 lg:w-20 z-50 text-gray-900/50"
            color="green"
          />
        </div>
      </div>
      <div class="w-full sm:w-1/2 lg:w-4/12  flex items-center justify-center">
        <div class=" mb-2 flex justify-center w-full ">
          <form
            style={{ width: "800px" }}
            class="mt-8 p-1  max-w-screen-lg sm:w-96"
          >
            <div
              class="mb-4 flex flex-col items:center shadow-2xl border-2 p-6  gap-1 "
              // style={{ height: "800px" }}
            >
              <h1
                class="text-center font-bold text-2xl text-white p-2"
                style={{ backgroundColor: "#0B5F68" }}
              >
                Payment Verification
              </h1>
              <div class="p-2 w-full">
                <div class="relative">
                  <label for="method" class="leading-7 text-sm text-gray-600">
                    Select Method <br />
                    برائے کرم وہ اکاؤنٹ منتخب کریں جس میں آپ نے فیس ٹرانسفر کی ہے۔
                  </label>
                  <select
                    id="method"
                    name="method"
                    value={selectMethod}
                    onChange={handleMethodChange}
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-2 px-3 transition-colors duration-200 ease-in-out"
                  >
                    <option value="">Select Method</option>
                    <option value="EasyPaisa">EasyPaisa</option>
                    <option value="Bank">Bank</option>
                  </select>
                </div>
              </div>
              <div class="p-2 w-full">
                <div class="relative">
                  <label for="rolNum" class="leading-7 text-sm text-gray-600">
                    Roll Number
                  </label>
                  <PatternFormat
                    id="rolNum"
                    name="roll"
                    placeholder="Roll Number"
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    format="####"
                    mask="-"
                    value={rollNumber}
                    onValueChange={(values) => {
                      // Update the rollNumber state when the input value changes
                      setRollNumber(values.formattedValue);
                    }}
                  />
                </div>
              </div>

              <div class="p-2 w-full">
                <div class="relative">
                  <label for="name" class="leading-7 text-sm text-gray-600">
                    Name
                  </label>
                  <input
                   disabled
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Name"
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>


              <div class="p-2 w-full">
                <div class="relative">
                  <label for="phone" class="leading-7 text-sm text-gray-600">
                    Phone
                  </label>
                  <PatternFormat
                    placeholder="0000-0000000"
                    id="phone"
                    name="phone"
                    disabled
                    className="w-full input_num bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    format="####-#######"
                    mask="-"
                    value={phone}
                    onValueChange={(values) => {
                      // Update the phone state when the input value changes
                      setPhone(values.formattedValue);
                    }}
                  />
                </div>
              </div>

              <div class="p-2 w-full">
                <div class="relative">
                  <label for="batch" class="leading-7 text-sm text-gray-600">
                   
                  </label>
                  <input
                  hidden
                    type="text"
                    id="batch"
                    name="batch"
                    placeholder="Batch"
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    value={batch}
                    onChange={(e) => setBatch(e.target.value)}
                  />
                </div>
              </div>

              <div class="p-2 w-full">
                <div class="relative">
                  <label for="course" class="leading-7 text-sm text-gray-600">
                   
                  </label>
                  <input
                  hidden
                    type="text"
                    id="course"
                    name="course"
                   
                    placeholder="Course"
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    value={course}
                    onChange={(e) => setCourse(e.target.value)}
                  />
                </div>
              </div>
         
              <label
                class="text-center font-bold mt-4"
                style={{ color: "#0B5F68" }}
              >
                Upload Payment Picture
              </label>
              <div class="flex items-center justify-center w-full mt-5">
                <label
                  for="dropzone-file"
                  class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      id="svg"
                      class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <div id="show" class="bg-transparent hidden h-64 w-96">
                      <img id="img" class="h-full w-full" alt="" />
                    </div>
                    <div id="svg2">
                      <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                        <span class="font-semibold">Click to upload</span> or
                        drag and drop
                      </p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">
                        SVG, PNG, JPG or GIF (MAX. 800x400px)
                      </p>
                    </div>
                  </div>
                  <input
                    id="dropzone-file"
                    onChange={() => {
                      viewPic();
                    }}
                    type="file"
                    class="hidden"
                  />
                </label>
              </div>
              <br />
             
              <Button
                style={{ backgroundColor: "#0B5F68" }}
                onClick={Submit}
                fullWidth
                disabled={isButtonDisabled} // Set the disabled attribute based on the state
              >
                Save
              </Button>

              <br />
              <br />
              <br />
            </div>

            <br />
         
            <br />
          </form>
        </div>
      </div>
    </div>
  );
}